import logo from "../../images/VCallLogo.svg";
import { AppBar, Toolbar, Box } from "@mui/material";
import React from "react";

const HeaderWithoutSignIn: React.FC = () => {
  return (
    <AppBar position="static" style={{ backgroundColor: "#f6b602" }}>
      <Toolbar>
        <Box component="img" src={logo} alt="Logo" sx={{ height: 30, mr: 2 }} />
      </Toolbar>
    </AppBar>
  );
};

export default HeaderWithoutSignIn;
